module.exports = __webpack_public_path__ + "img/CAL-UHF-Zubehörkoffer_transparent_Var2.5a12bd7c.jpg";